import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "grid"
    }}>{`Grid`}</h1>
    <p>{`The Grid section allows you to add a grid to your search page, here we will discuss about the option that is provide by the grid panel,`}</p>
    <p>{`you can add a grid section from the `}<em parentName="p">{`Add Block`}</em>{`,`}</p>
    <p><img alt="AddGrid.png" src={require("../images/AddGrid.png")} />{`
`}<img alt="AddGrid2.png" src={require("../images/AddGrid2.png")} /></p>
    <p>{`after you add a grid the default Simple layout grid will be loaded with maximum 12 posts in 2 column grid, this are the default settings and if you want to change them you chan change it easily, just follow the below steps,`}</p>
    <p><img alt="GridShow.png" src={require("../images/GridShow.png")} /></p>
    <h2 {...{
      "id": "appearance"
    }}>{`Appearance:`}</h2>
    <p>{`From the Appearacne menu you can add grid or list wrapper class, cahange number off post per page,`}</p>
    <p>{`you can also change the default view list or grid it will work only if the grid support list view,`}</p>
    <p>{`and instead of using pagination you can use the load more option.`}</p>
    <p><img alt="GridA.png" src={require("../images/GridA.png")} /></p>
    <h2 {...{
      "id": "gridcolumn-or-listcolumn"
    }}>{`Gridcolumn or Listcolumn:`}</h2>
    <p>{`you can choose number of column your grid or list should have.`}</p>
    <p><img alt="GridColumn.png" src={require("../images/GridColumn.png")} />{`
`}<img alt="GridList.png" src={require("../images/GridList.png")} /></p>
    <h2 {...{
      "id": "layouts"
    }}>{`Layouts:`}</h2>
    <p>{`Here, you can choose the layouts you wanted to show in your search page.`}</p>
    <p><img alt="GridLayouts.png" src={require("../images/GridLayouts.png")} /></p>
    <h2 {...{
      "id": "previewpop-up"
    }}>{`PreviewPop Up:`}</h2>
    <p>{`Preview Pop up feature is provided Which will pop up the grid item information upon gird item click.`}</p>
    <p><img alt="previewPopOver.png" src={require("../images/previewPopOver.png")} /></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      